<div
  [ngClass]="{
    'list-item': !isToolbar
  }"
>
  <ng-content></ng-content>
  <ng-template vaControlHost></ng-template>
</div>
